/**
 * @generated SignedSource<<01ca1d5d5c79a7cea93cac4deaf18160>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResyncCalendarMutation$variables = {
  currentDate?: string | null;
};
export type ResyncCalendarMutation$data = {
  readonly resyncCalendar: {
    readonly asyncResultId: any | null;
    readonly error: {
      readonly __typename: string;
      readonly message: string | null;
      readonly service?: string | null;
    } | null;
    readonly ok: boolean | null;
  } | null;
};
export type ResyncCalendarMutation = {
  response: ResyncCalendarMutation$data;
  variables: ResyncCalendarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentDate"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "currentDate",
        "variableName": "currentDate"
      }
    ],
    "concreteType": "ResyncCalendar",
    "kind": "LinkedField",
    "name": "resyncCalendar",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "service",
                "storageKey": null
              }
            ],
            "type": "ReauthError",
            "abstractKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResyncCalendarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResyncCalendarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6a284eafcf6d3ff8f807e181bd7c43de",
    "id": null,
    "metadata": {},
    "name": "ResyncCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation ResyncCalendarMutation(\n  $currentDate: String\n) {\n  resyncCalendar(currentDate: $currentDate) {\n    ok\n    error {\n      __typename\n      ... on ReauthError {\n        service\n      }\n      message\n    }\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c16bc25d09456e84b68305861d014845";

export default node;
